module.exports = __webpack_public_path__ + "img/stress_estimate3.95cdf63c.png";